<div
  class="tw-flex tw-flex-col tw-max-w-full tw-bg-gray-900 tw-text-gray-100 tw-rounded-lg tw-shadow-xl tw-max-h-[90vh]">
  <!-- Header -->
  <div class="tw-flex-shrink-0 tw-p-6 tw-pb-0">
    <h2
      class="tw-text-xl sm:tw-text-2xl tw-font-semibold tw-text-white tw-mt-0 tw-mb-2 tw-flex tw-items-center tw-gap-2">
      {{ data?.role ? 'View Role' : 'Create New Role' }}

      <!-- Role tags -->
      <!-- 
      <ng-container *ngIf="data?.role?.tags && data?.role?.tags.length > 0">
        <span
          *ngFor="let tag of data?.role?.tags"
          [ngClass]="{
                'tw-bg-purple-700/60': tag === 'recently-used',
                'tw-bg-yellow-700/60': tag === 'popular'
              }"
          class="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-normal tw-ml-2">
          {{ tag === 'recently-used' ? 'Recent' : tag === 'popular' ? 'Popular' : tag }}
        </span>
      </ng-container>
      -->
    </h2>
    <p class="tw-text-gray-400 tw-text-sm tw-m-0">Define criteria to find matching job titles</p>
    <!-- Role metadata - only shown in view mode for non-public roles -->
    <div
      *ngIf="data?.role?.createdAt && data?.role?.scope !== 'public'"
      class="tw-mt-2 tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-bg-slate-700/50 tw-rounded-full tw-px-3 tw-py-1 tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-gray-400 tw-text-sm" inline>person</mat-icon>
        <span class="tw-text-gray-300 tw-text-xs">
          Created by {{ data.role.createdBy || 'Unknown' }}
        </span>
      </div>
      <div
        class="tw-bg-slate-700/50 tw-rounded-full tw-px-3 tw-py-1 tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-gray-400 tw-text-sm" inline>calendar_today</mat-icon>
        <span class="tw-text-gray-300 tw-text-xs">
          {{ data.role.createdAt | date:'MMM d, yyyy' }}
        </span>
      </div>
    </div>
    <!-- cancel button -->
    <button (click)="onCancel()" mat-icon-button class="tw-absolute tw-top-4 tw-right-4">
      <mat-icon class="tw-text-gray-400">close</mat-icon>
    </button>
  </div>

  <!-- Scrollable Content Area -->
  <div class="tw-flex-1 tw-overflow-y-auto tw-custom-scrollbar tw-px-6">
    <div class="tw-flex tw-flex-col mdx:tw-flex-row tw-gap-6 tw-py-4">
      <!-- Left Column: Form -->
      <div class="tw-w-full mdx:tw-w-3/5">
        <form [formGroup]="roleForm" class="tw-flex tw-flex-col tw-gap-6">
          <!-- Basic Info Section -->
          <div class="tw-bg-slate-700/30 tw-rounded-lg tw-p-5 tw-shadow-inner">
            <mat-form-field appearance="outline" class="tw-w-full">
              <mat-label>Role Name</mat-label>
              <input
                matInput
                formControlName="name"
                placeholder="e.g., Senior Data Analyst"
                class="tw-text-white" />
              <mat-error *ngIf="roleForm.controls.name.hasError('required')">
                Name is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="tw-w-full tw-mt-4">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                formControlName="description"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="4"
                placeholder="Describe this role's responsibilities and requirements"
                class="tw-text-white"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="tw-w-full tw-mt-4">
              <mat-label>Category</mat-label>
              <input
                matInput
                formControlName="category"
                placeholder="e.g., Technical, Sales, etc"
                class="tw-text-white" />
            </mat-form-field>
          </div>

          <!-- Keyword Criteria Section -->
          <div formGroupName="criteria" class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
            <!-- Included Keywords -->
            <div class="tw-bg-slate-700/30 tw-rounded-lg tw-p-5 tw-shadow-inner">
              <h3
                class="tw-text-lg tw-font-medium tw-flex tw-items-center tw-mb-2 tw-mt-0 tw-text-blue-400 tw-gap-2">
                <mat-icon inline>add_circle</mat-icon>
                Include Keywords
              </h3>
              <p class="tw-text-gray-400 tw-text-sm tw-m-0 tw-mb-6">
                Include titles that contain these keywords<br />
                <span class="tw-text-xs tw-text-gray-500"
                  >Tip: Paste lists separated by commas or newlines</span
                >
              </p>

              <mat-form-field appearance="outline" class="tw-w-full tw-mb-8">
                <mat-label>Fuzzy Match</mat-label>
                <mat-chip-grid
                  #chipGridMustFuzzy
                  formControlName="mustFuzzy"
                  class="tw-min-h-[45px]">
                  <mat-chip-row
                    *ngFor="let keyword of mustFuzzy.value"
                    (removed)="remove(keyword, mustFuzzy)"
                    class="tw-bg-blue-600/40 tw-text-white">
                    {{keyword}}
                    <button matChipRemove [attr.aria-label]="'remove ' + keyword">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input
                  placeholder="Type and press enter or paste a list"
                  [matChipInputFor]="chipGridMustFuzzy"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event, mustFuzzy)"
                  (paste)="onPaste($event, mustFuzzy)" />
                <mat-hint
                  [class.tw-text-orange-500]="mustFuzzy.value.length >= MAX_VALUES_PER_CRITERIA"
                  [class.tw-text-gray-400]="mustFuzzy.value.length < MAX_VALUES_PER_CRITERIA"
                  class="tw-text-sm">
                  <span *ngIf="mustFuzzy.value.length < MAX_VALUES_PER_CRITERIA"
                    >Terms appear anywhere in the title</span
                  >
                  <span *ngIf="mustFuzzy.value.length >= MAX_VALUES_PER_CRITERIA"
                    >Maximum {{MAX_VALUES_PER_CRITERIA}} values allowed</span
                  >
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="tw-w-full">
                <mat-label>Exact Match</mat-label>
                <mat-chip-grid
                  #chipGridMustExact
                  formControlName="mustExact"
                  class="tw-min-h-[45px]">
                  <mat-chip-row
                    *ngFor="let keyword of mustExact.value"
                    (removed)="remove(keyword, mustExact)"
                    class="tw-bg-blue-700/60 tw-text-white">
                    {{keyword}}
                    <button matChipRemove [attr.aria-label]="'remove ' + keyword">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input
                  placeholder="Type and press enter or paste a list"
                  [matChipInputFor]="chipGridMustExact"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event, mustExact)"
                  (paste)="onPaste($event, mustExact)" />
                <mat-hint
                  [class.tw-text-orange-500]="mustExact.value.length >= MAX_VALUES_PER_CRITERIA"
                  [class.tw-text-gray-400]="mustExact.value.length < MAX_VALUES_PER_CRITERIA"
                  class="tw-text-sm">
                  <span *ngIf="mustExact.value.length < MAX_VALUES_PER_CRITERIA"
                    >Titles exactly match these terms</span
                  >
                  <span *ngIf="mustExact.value.length >= MAX_VALUES_PER_CRITERIA"
                    >Maximum {{MAX_VALUES_PER_CRITERIA}} values allowed</span
                  >
                </mat-hint>
              </mat-form-field>
            </div>

            <!-- Excluded Keywords -->
            <div class="tw-bg-slate-700/30 tw-rounded-lg tw-p-5 tw-shadow-inner">
              <h3
                class="tw-text-lg tw-font-medium tw-flex tw-items-center tw-mb-2 tw-mt-0 tw-text-red-300 tw-gap-2">
                <mat-icon inline>remove_circle</mat-icon>
                Exclude Keywords
              </h3>
              <p class="tw-text-gray-400 tw-text-sm tw-m-0 tw-mb-6">
                Exclude titles that contain these keywords
                <span class="tw-text-xs tw-text-gray-500"
                  >Tip: Paste lists separated by commas or newlines</span
                >
              </p>

              <mat-form-field appearance="outline" class="tw-w-full tw-mb-8">
                <mat-label>Fuzzy Match</mat-label>
                <mat-chip-grid
                  #chipGridMustNotFuzzy
                  formControlName="mustNotFuzzy"
                  class="tw-min-h-[45px]">
                  <mat-chip-row
                    *ngFor="let keyword of mustNotFuzzy.value"
                    (removed)="remove(keyword, mustNotFuzzy)"
                    class="tw-bg-red-600/40 tw-text-white">
                    {{keyword}}
                    <button matChipRemove [attr.aria-label]="'remove ' + keyword">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input
                  placeholder="Type keywords or paste a list"
                  [matChipInputFor]="chipGridMustNotFuzzy"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event, mustNotFuzzy)"
                  (paste)="onPaste($event, mustNotFuzzy)" />
                <mat-hint
                  [class.tw-text-orange-500]="mustNotFuzzy.value.length >= MAX_VALUES_PER_CRITERIA"
                  [class.tw-text-gray-400]="mustNotFuzzy.value.length < MAX_VALUES_PER_CRITERIA"
                  class="tw-text-sm">
                  <span *ngIf="mustNotFuzzy.value.length < MAX_VALUES_PER_CRITERIA"
                    >Terms appear anywhere in the title</span
                  >
                  <span *ngIf="mustNotFuzzy.value.length >= MAX_VALUES_PER_CRITERIA"
                    >Maximum {{MAX_VALUES_PER_CRITERIA}} values allowed</span
                  >
                </mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="tw-w-full">
                <mat-label>Exact Match</mat-label>
                <mat-chip-grid
                  #chipGridMustNotExact
                  formControlName="mustNotExact"
                  class="tw-min-h-[45px]">
                  <mat-chip-row
                    *ngFor="let keyword of mustNotExact.value"
                    (removed)="remove(keyword, mustNotExact)"
                    class="tw-bg-red-600/40 tw-text-white">
                    {{keyword}}
                    <button matChipRemove [attr.aria-label]="'remove ' + keyword">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input
                  placeholder="Type keywords or paste a list"
                  [matChipInputFor]="chipGridMustNotExact"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event, mustNotExact)"
                  (paste)="onPaste($event, mustNotExact)" />
                <mat-hint
                  [class.tw-text-orange-500]="mustNotExact.value.length >= MAX_VALUES_PER_CRITERIA"
                  [class.tw-text-gray-400]="mustNotExact.value.length < MAX_VALUES_PER_CRITERIA"
                  class="tw-text-sm">
                  <span *ngIf="mustNotExact.value.length < MAX_VALUES_PER_CRITERIA"
                    >Titles exactly match these terms</span
                  >
                  <span *ngIf="mustNotExact.value.length >= MAX_VALUES_PER_CRITERIA"
                    >Maximum {{MAX_VALUES_PER_CRITERIA}} values allowed</span
                  >
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>

      <!-- Right Column: Preview -->
      <div
        class="tw-w-full mdx:tw-w-2/5 tw-bg-slate-700/30 tw-rounded-lg tw-shadow-inner tw-flex tw-flex-col">
        <div class="tw-p-6 tw-pb-4">
          <!-- Role Statistics -->
          <div class="tw-mb-4">
            <h3 class="tw-text-lg tw-font-bold tw-text-gray-200 tw-m-0 tw-mb-2">Role Statistics</h3>
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-gray-300">
              <mat-icon inline class="tw-text-blue-400 tw-text-sm">people</mat-icon>
              <span class="tw-text-sm">
                <span class="tw-font-semibold tw-text-white">{{totalPeople | number}}</span>
                matching people in Workforce
              </span>
            </div>
          </div>

          <div class="tw-mt-8">
            <h3 class="tw-text-base tw-font-bold tw-text-gray-200 tw-m-0">
              Top 25 Matching Titles
            </h3>
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-gray-300 tw-text-sm">
              Use these to refine your match and exclusion criteria.
            </div>
          </div>
        </div>

        <div class="tw-flex-1 tw-px-6 tw-pb-6">
          <div
            class="tw-h-full tw-min-h-[200px] tw-max-h-[400px] tw-overflow-y-auto tw-custom-scrollbar tw-relative"
            [class.tw-opacity-50]="isLoadingTitles && matchingTitles.length > 0">
            <!-- Loading spinner - always shows when loading -->
            <div
              *ngIf="isLoadingTitles"
              class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-slate-700/20 tw-backdrop-blur-sm tw-z-10">
              <mat-spinner diameter="40" strokeWidth="3" class="tw-opacity-80"></mat-spinner>
            </div>

            <!-- Empty state - only show when not loading and no results -->
            <div
              *ngIf="matchingTitles.length === 0 && !isLoadingTitles"
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-64 tw-text-center tw-text-gray-400">
              <mat-icon class="tw-text-5xl tw-mb-4 tw-opacity-30 tw-w-12 tw-h-12">
                search_off
              </mat-icon>
              <p class="tw-text-lg tw-font-medium tw-m-0">No matching titles yet</p>
              <p class="tw-text-sm tw-mt-2">Try adding some keywords to see matching titles</p>
            </div>

            <ul
              *ngIf="matchingTitles.length > 0"
              class="tw-space-y-2 tw-list-none tw-list-inside tw-p-0 tw-m-0">
              <li
                *ngFor="let titleData of matchingTitles; let i = index"
                class="tw-px-3 tw-py-2 tw-rounded tw-bg-slate-600/30 tw-border-0 tw-border-l-4 tw-border-solid tw-border-slate-500">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <mat-icon inline class="tw-text-sm tw-opacity-60">work</mat-icon>
                  <span class="tw-text-gray-300 tw-text-sm">{{ titleData.title }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sticky Action Buttons -->
  <div
    class="tw-flex-shrink-0 tw-flex tw-justify-between tw-items-center tw-p-6 tw-pt-4 tw-border-t tw-border-slate-600/30">
    <!-- Delete button - only for existing roles that are not public -->
    <button
      *ngIf="data?.role && data?.role?.scope !== 'public'"
      mat-button
      color="warn"
      type="button"
      (click)="onDelete()"
      class="tw-text-red-400 hover:tw-text-red-300">
      <span class="tw-flex tw-items-center tw-gap-2">
        <mat-icon inline>delete</mat-icon>
        Delete
      </span>
    </button>

    <!-- Spacer for alignment when no delete button -->
    <div *ngIf="!data?.role || data?.role?.scope === 'public'"></div>

    <!-- Right side buttons -->
    <div class="tw-flex tw-gap-3">
      <button mat-button type="button" (click)="onCancel()" class="tw-text-gray-300">Cancel</button>

      <!-- Save as New button - only for existing roles -->
      <div
        *ngIf="data?.role"
        [matTooltip]="!canSaveAsNew ? 'Change the name to save as a new role' : ''"
        matTooltipPosition="above"
        class="tw-inline-block">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="onSaveAsNew()"
          [disabled]="!canSaveAsNew">
          <span class="tw-flex tw-items-center tw-gap-2">
            <mat-icon inline>add</mat-icon>
            Save as New
          </span>
        </button>
      </div>

      <button
        *ngIf="!data?.role || data?.role?.scope !== 'public'"
        mat-flat-button
        color="primary"
        type="button"
        (click)="onCreate()"
        [disabled]="!canSave">
        <span class="tw-flex tw-items-center tw-gap-2">
          <mat-icon inline>save</mat-icon>
          Save
        </span>
      </button>
    </div>
  </div>
</div>
